import { Store } from '@ngxs/store'
import { Injectable } from '@angular/core'
import { QuoteMetaState } from 'src/store/quote/quote.meta.state'
import { ProductTypes } from '../smart-suggestion.model'

/**
 * POLICY: BYD2-238
 * Description: The quantity of connectors per port on the inverter
 */

@Injectable({ providedIn: 'root' })
export class ConnectorsHelper {
  constructor(private store: Store) {}

  getConnectorsSuggestions() {
    const selectedInverters = this.store.selectSnapshot(
      QuoteMetaState.getSelectedInverters,
    )
    if (selectedInverters.length === 0) {
      return []
    }
    const needPorts = selectedInverters.reduce((acc, inverter) => {
      return acc + inverter.quantity * inverter?.inputs || 0
    }, 0)
    console.log(
      '%cNEED PORTS ↓',
      'font-weight: bold; color: white; background-color: green;',
    )
    console.log(needPorts)

    const suggestions = this.getConnectorsOptions(needPorts)
    return suggestions
  }

  getConnectorsOptions(needPorts: number): any[] {
    const connectors = this.store
      .selectSnapshot(QuoteMetaState.getConnectors)
      .filter((connector) => connector.quantityInStock > 0)
    const foundSelected = connectors.find((connector) => connector.quantity > 0)
    const bestOptions = []

    for (const connector of connectors) {
      const bestQuantity = Math.ceil(needPorts / connector.pairsNumber) * 2
      const isSelected =
        foundSelected &&
        foundSelected.id === connector.id &&
        foundSelected.quantity === bestQuantity
      if (bestQuantity === 0) {
        continue
      }
      bestOptions.push({
        title: `${bestQuantity}x ${connector.title}`,
        isSelected,
        content: [
          {
            id: connector.id,
            type: ProductTypes.CONNECTOR,
            quantity: bestQuantity,
          },
        ],
      })
    }

    // The index 0 was used because in the iteration that was performed, there will only be 1 item in the content on any occasion.
    bestOptions.sort((a, b) => a.content[0].quantity - b.content[0].quantity)

    // The index 0 was used because it retrieves only what has the smallest quantity.
    return [bestOptions[0]]
  }
}
